import React, { useState, useEffect } from "react"
import { Drawer, Typography, Spin, List, Avatar } from "antd"
import { collection, doc, documentId, getDoc, getDocs, query, where } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import InvoicePDFPreview from "../../../Accounting/Invoices/Helper/InvoicePDFPreview"

const { Link } = Typography

export default function MissingDocList({ linkText, collectionName, ids = [] }) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  const showDrawer = () => setOpen(true)
  const closeDrawer = () => setOpen(false)

  useEffect(() => {
    // If the drawer is closed or there's nothing to fetch, clear & bail out
    if (!open || ids.length === 0) {
      setData([])
      return
    }

    let cancelled = false
    setLoading(true)

    const colRef = collection(db, collectionName)
    const q = query(colRef, where(documentId(), "in", ids))

    getDocs(q)
      .then((snap) => {
        if (cancelled) return

        // snap.docs is already only the existing docs
        const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        setData(docs)
      })
      .catch((err) => {
        console.error("Error fetching drawer items:", err)
        if (!cancelled) setData([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [open, collectionName, ids])

  return (
    <>
      <Link onClick={showDrawer} style={{ cursor: "pointer" }}>
        {linkText}
      </Link>
      <Drawer
        title={collectionName === "invoices" ? "Missing Invoices" : "Stuck Orders"}
        placement="right"
        width={400}
        onClose={closeDrawer}
        open={open}>
        {loading ? (
          <Spin tip="Loading..." />
        ) : (
          <List
            dataSource={data}
            rowKey="id"
            renderItem={(item) => (
              <List.Item>
                {/* Customize display based on collection */}
                {collectionName === "invoices" ? (
                  <>
                    <List.Item.Meta
                      avatar={
                        <Avatar src={<InvoicePDFPreview scale={3} pdfUrl={item?.downloadUrl} />} />
                      }
                      title={item.docPrefix + item.docNumber}
                      description={item.client?.client}
                    />
                    <div>&mdash; €{item.totalData?.totalSum}</div>
                  </>
                ) : (
                  <>
                    <b>{item.orderNumber || item.id}</b> &mdash; {item.client?.client} &mdash; €
                    {item.totalValue}
                  </>
                )}
              </List.Item>
            )}
          />
        )}
      </Drawer>
    </>
  )
}
